import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";

export default function InstructionTabPanel({
                                              InstructionComponent,
                                              compiledInstructions,
                                              rawInstructions,
                                              isEditing,
                                              editValue,
                                              onEdit,
                                              onSave,
                                              onCancel,
                                              onEditChange,
                                            }) {
  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Box flex={1}>
        <Typography sx={{ fontWeight: "bold", mb: 2 }}>For User:</Typography>
        <InstructionComponent
          {...{ instructions: compiledInstructions?.replace("replaceme", editValue) || rawInstructions }}
          dimm={true}
        />
      </Box>
      <Box flex={1}>
        <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
          <Typography sx={{ fontWeight: "bold", mb: 2 }}>In DB:</Typography>
          {!isEditing && (
            <IconButton size="small" onClick={onEdit} color="primary">
              <EditIcon fontSize="small" />
            </IconButton>
          )}
          {isEditing && (
            <>
              <IconButton size="small" onClick={onSave} color="success">
                <SaveIcon fontSize="small" />
              </IconButton>
              <IconButton size="small" onClick={onCancel} color="error">
                <CancelIcon fontSize="small" />
              </IconButton>
            </>
          )}
        </Box>
        {isEditing ? (
          <TextField
            fullWidth
            multiline
            rows={4}
            value={editValue}
            onChange={onEditChange}
            variant="outlined"
          />
        ) : (
          <Typography>
            <span dangerouslySetInnerHTML={{ __html: rawInstructions }} />
          </Typography>
        )}
      </Box>
    </Box>
  );
}

